import * as Yup from 'yup';

import { Clinic, ClinicBillingType, Professional } from './types';
import { PERSON_KIND } from './constants';

export const requiredKeysForClinic = [
  'address',
  'number',
  'neighborhood',
  'city',
  'state',
  'zip_code',
];
export const requiredKeysForProfessional = [
  'council_name',
  'council_number',
  'council_region',
  'cbo',
];

export const requiredKeysForClinicBilling = [
  'person_kind',
  'responsible',
  'cpf_cnpj',
  'billing_address',
  'billing_number',
  'billing_neighborhood',
  'billing_city',
  'billing_state',
  'billing_zip',
];

const buildSchema = (
  keys: string[],
): Yup.ObjectSchema<Record<string, Yup.StringSchema>> => {
  const shape: Record<string, Yup.StringSchema> = {};
  keys.forEach((key) => {
    shape[key] = Yup.string().required();
  });
  return Yup.object().shape(shape);
};

const clinicSchema = buildSchema(requiredKeysForClinic);

export const isClinicIncomplete = (
  clinic: Clinic | Record<string, unknown>,
): boolean => !clinicSchema.isValidSync(clinic);

const professionalSchema = buildSchema(requiredKeysForProfessional).concat(
  Yup.object().shape({
    profile: Yup.object().shape({
      cpf: Yup.string().required(),
    }),
  }),
);

export const isProfessionalIncomplete = (
  professional: Professional | Record<string, unknown>,
): boolean => !professionalSchema.isValidSync(professional);

const clinicBillingSchema = buildSchema(requiredKeysForClinicBilling).concat(
  Yup.object().shape({
    billing_birthdate: Yup.string().when('person_kind', {
      is: (val: string) => val === PERSON_KIND.PF,
      then: Yup.string().required(),
      otherwise: Yup.string().notRequired(),
    }),
  }),
);

export const isBillingIncomplete = (
  billing: ClinicBillingType | Record<string, unknown>,
): boolean => !clinicBillingSchema.isValidSync(billing);

export const customizeErrorMessage = (error: unknown): string =>
  error instanceof Error && error.message ? error.message : String(error);

export const isoToBrDate = (value: string): string => {
  if (!value) return '';
  const [year, month, day] = value.split('-');
  if (year && month && day) return `${day}/${month}/${year}`;
  return value;
};
